export default __webpack_public_path__ + "static/media/baloon.d02e4ee0.svg";